module.exports = __webpack_public_path__ + "static/media/CarryOn_LargeLaggage_Arrows_iOS13.98f0c407.usdz";